export default {
  appBarHeight: 58,
  sidebarWidth: 280,
  authSidebarWidth: 350,
};
